import { useEffect, useState } from 'react';
import { Redirect, Switch, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './ApplicationState';
import { removeLocalStorage } from './aaa';
import StudentHeader from './components/StudentHeader';
import ToDosPage from './ToDosPage';
import CheckIn from './CheckIn';
import StudentStrengths from './StudentStrengths';
import MiddleSchoolAccountSettings from './MiddleSchoolAccountSettings';
import ToDoContainer from './ToDoContainer';
import ToDoConfirm from './ToDoConfirm';
import StudentFooter from './components/StudentFooter';
import AuthenticatedRoute from './AuthenticatedRoute';

interface urlParams {
  toDo: string;
  grade: string;
  language: string;
  activity: string;
}

const MiddleSchoolStudentLayout = (): JSX.Element => {
  const [currentToDo, setCurrentToDo] = useState(null);
  const [groupedToDoInfo, setGroupedToDoInfo] = useState(null);
  const [activePage, setActivePage] = useState('');
  const userProfile = useSelector((state: RootState) => state.user.userProfile);

  const location = useLocation();
  const { toDo }: urlParams = useParams();

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (!toDo) {
      removeLocalStorage('currentToDo');
      removeLocalStorage('groupedToDoInfo');
    }
  }, [toDo]);

  return (
    <div className='applicationLayout'>
      <StudentHeader activePage={activePage} />
      <Switch>
        <AuthenticatedRoute path='/studentportal/toDos'>
          <ToDosPage setCurrentToDo={setCurrentToDo} setGroupedToDoInfo={setGroupedToDoInfo} />
        </AuthenticatedRoute>
        <AuthenticatedRoute path='/studentportal/checkin'>
          <CheckIn />
        </AuthenticatedRoute>
        <AuthenticatedRoute path='/studentportal/strengths'>
          {userProfile?.grade > 8 ? <StudentStrengths /> : <Redirect to='/studentportal/toDos' />}
        </AuthenticatedRoute>
        <AuthenticatedRoute path='/studentportal/accountSettings'>
          <MiddleSchoolAccountSettings />
        </AuthenticatedRoute>
        <AuthenticatedRoute path='/studentportal/activity/:activity/:language/:grade/toDo/:toDo/confirmation'>
          <ToDoConfirm
            currentToDo={currentToDo}
            setCurrentToDo={setCurrentToDo}
            setGroupedToDoInfo={setGroupedToDoInfo}
          />
        </AuthenticatedRoute>
        <AuthenticatedRoute path='/studentportal/activity/:activity/:language/:grade/toDo/:toDo/review'>
          <ToDoContainer currentToDo={currentToDo} />
        </AuthenticatedRoute>

        <AuthenticatedRoute path='/studentportal/activity/:activity/:language/:grade/toDo/:toDo'>
          <ToDoContainer
            currentToDo={currentToDo}
            groupedToDoInfo={groupedToDoInfo}
            setCurrentToDo={setCurrentToDo}
            setGroupedToDoInfo={setGroupedToDoInfo}
          />
        </AuthenticatedRoute>
      </Switch>
      <StudentFooter />
    </div>
  );
};

export default MiddleSchoolStudentLayout;
